<template>
  <div style="margin: 0px 50px">
    <!--新增已有的fm-->
    <div v-if="isDone">
<!--      <el-button size="mini" class="el-icon-plus" type="primary" @click="addFMnew()">添加</el-button>-->
      <div style="height: 40px;width: 100%;margin-top: -20px">
        <div class="add-open-btn" @click="addFMnew()">
          <strong>+</strong>
        </div>
      </div>
      <div style="max-height: 280px;overflow-y: auto">
        <el-table
          :data="showTable"
          size="mini"
          style="width: 100%;border-top: 1px solid #EBEEF5"
          highlight-current-row
          ref="multipleTable"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
            :selectable='checkboxSelect'
          align="center">
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="50"
            align="center">
          </el-table-column>
          <el-table-column
            prop="fm_name"
            label="电台名称"
            min-width="85"
            align="center">
          </el-table-column>
          <el-table-column
            prop="fm_frequency"
            label="电台频率"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column
            prop="create_tm"
            label="创建时间"
            min-width="140"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="60">
            <template slot-scope="scope">
              <i title="刪除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delFm(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
      <div style="margin-top: 10px">
        <el-row style="margin: 0 50px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeOpen()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAdd()">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--新增、编辑-->
    <div v-else>
      <el-form style="margin-right: 40px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="电台频率" prop="frequency">
          <el-input v-model="addEditForm.frequency" placeholder="请输入电台频率"></el-input>
        </el-form-item>
        <el-form-item label="电台名称" prop="name">
          <el-input v-model="addEditForm.name" placeholder="请输入电台名称"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 30px">
        <el-row style="margin: 0 50px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeOpen1()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submit('addEditForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>

<script>
import {queryfminfo, addfminfo, addfmdevice, deletefminfo} from '../../../api/device'
import {addfmdevicebyorg} from '../../../api/organizer'

export default {
  name: 'addEditFM',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    FMObj: {
      type: Object,
      default: null
    }
  },
  data () {
    const validateFrequency = (rule, value, callback) => {
      // console.log('fm', value)
      let arr = value.split('.')
      if (value === '') {
        callback(new Error('请输入FM频率'))
      } else if (arr.length > 2) {
        callback(new Error('输入FM频率格式不正确'))
      } else {
        callback()
      }
    }
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      addEditForm: {
        name: '',
        frequency: '',
        topic: '' // topic 暂为空
      },
      addEditRules: {
        name: [
          { required: true, message: '请输入电台名称', trigger: 'blur' }
        ],
        frequency: [
          { required: true, trigger: 'blur', validator: validateFrequency }
        ]
      },
      isDone: true,
      fmids: [],
      selectIds: []
    }
  },
  created () {
    /* 设备管理fmInfo 组织管理orgFmInfo */
    // 判断编辑
    // console.log(this.FMObj)
    this.selectIds = this.FMObj.selectIds
    if (!this.FMObj.isAdd) {
      this.isDone = false
    } else {
      this.getFmInfo()
    }
  },
  methods: {
    // 获取已有FM
    getFmInfo () {
      if (this.FMObj.devicerow.id) {
        this.getFmInfoDid()
      }
      if (this.FMObj.orgRow.id) {
        this.getFmInfoOrg()
      }
    },
    // 获取设备已有FM
    getFmInfoDid () {
      // console.log('设备已有FM')
      let data = {
        did: this.FMObj.devicerow.id,
        page: this.currentPage,
        size: this.pageSize
      }
      queryfminfo(data).then(res => {
        let arr = []
        this.totalCells = res.data.cnt
        this.showTable = res.data.fminfo
        for (let i = 0; i < this.showTable.length; i++) {
          if (this.selectIds.indexOf(this.showTable[i].id) > -1) {
            arr.push(this.showTable[i])
          }
        }
        let vm = this
        setTimeout(() => {
          vm.toggleSelection(arr)
        }, 200)
      }).catch(() => {})
    },
    toggleSelection (rows) {
      // console.log(rows)
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },
    // 获取组织已有FM
    getFmInfoOrg () {
      // console.log('组织已有FM')
      let data = {
        did: '',
        page: this.currentPage,
        size: this.pageSize
      }
      queryfminfo(data).then(res => {
        let arr = []
        this.totalCells = res.data.cnt
        this.showTable = res.data.fminfo
        for (let i = 0; i < this.showTable.length; i++) {
          if (this.selectIds.indexOf(this.showTable[i].id) > -1) {
            arr.push(this.showTable[i])
          }
        }
        let vm = this
        setTimeout(() => {
          vm.toggleSelection(arr)
        }, 200)
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getFmInfo()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getFmInfo()
    },
    closeOpen () {
      this.$emit('change', false)
    },
    closeOpen1 () {
      this.isDone = true
    },
    addFMnew () {
      this.isDone = false
    },
    handleSelectionChange (val) {
      this.fmids = []
      if (this.FMObj.devicerow.id) {
        for (let i = 0; i < val.length; i++) {
          this.fmids.push(val[i].id)
        }
      } else {
        for (let i = 0; i < val.length; i++) {
          if (this.selectIds.indexOf(val[i].id) === -1) {
            this.fmids.push(val[i].id)
          }
        }
      }
    },
    checkboxSelect (row, rowIndex) {
      if (this.FMObj.orgRow.id) {
        if (this.selectIds.indexOf(row.id) === -1) {
          return true // 不禁用
        } else {
          return false // 禁用
        }
      } else {
        return true
      }
      // if (rowIndex === 0) {
      //   return false // 禁用
      // } else {
      //   return true // 不禁用
      // }
    },
    submitAdd () {
      if (this.FMObj.isAdd) {
        if (this.FMObj.devicerow.id) {
          // console.log('设备')
          let data = {
            did: this.FMObj.devicerow.id,
            imei: this.FMObj.devicerow.deviceid,
            fmid: this.fmids
          }
          addfmdevice(data).then(res => {
            this.$emit('getFather')
            this.$notify({
              title: '成功',
              message: '成功设置FM频率',
              type: 'success',
              duration: 2000
            })
            this.$emit('change', false)
          }).catch(() => {})
        }
        if (this.FMObj.orgRow.id) {
          // console.log('组织')
          let data = {
            zonetopic: this.FMObj.orgRow.mqttlevel, // string 组织topic
            device_type: 700,
            fmid: this.fmids,
            oid: this.FMObj.orgRow.id
          }
          addfmdevicebyorg(data).then(res => {
            this.$emit('getFather')
            this.$notify({
              title: '成功',
              message: '成功设置FM频率',
              type: 'success',
              duration: 2000
            })
            this.$emit('change', false)
          }).catch(() => {})
        }
      }
    },
    // 设置设备添加FM
    setDidFM (row) {
      // console.log(row)
      let name = row.fm_name
      this.$confirm('确定该电台【' + name + '】设置到设备【' + this.FMObj.devicerow.deviceid + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          did: this.FMObj.devicerow.id,
          imei: this.FMObj.devicerow.deviceid,
          fmid: [row.id]
        }
        addfmdevice(data).then(res => {
          this.$emit('getFather')
          this.$notify({
            title: '成功',
            message: '设备成功设置电台FM',
            type: 'success',
            duration: 2000
          })
          this.$emit('change', false)
        }).catch(() => {})
      }).catch(() => {})
    },
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.FMObj.isAdd) {
            let data = {
              name: this.addEditForm.name,
              frequency: this.addEditForm.frequency,
              topic: this.$store.state.user.mqtts[0]
            }
            addfminfo(data).then(res => {
              this.getFmInfo()
              this.isDone = true
              this.$notify({
                title: '成功',
                message: '成功添加FM电台',
                type: 'success',
                duration: 2000
              })
            }).catch(() => {})
          } else {
            // 暂无设置
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除fm
    delFm (row) {
      let name = row.fm_name
      this.$confirm('此操作将永久删除该FM【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          fmid: [row.id]
        }
        deletefminfo(data).then(() => {
          if (this.showTable.length === 1 && this.currentPage > 1) {
            this.currentPage -= 1
          }
          this.getFmInfo()
          this.$notify({
            title: '成功',
            message: '成功删除',
            type: 'success',
            duration: 2000
          })
        }).catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/addEditFM.vue